module.exports = __webpack_public_path__ + "static/media/bell_beaker_spain_text_01.ba3e86d5.jpg";